import { connect } from 'react-redux';

import { MaintenanceReminders } from './MaintenanceReminders';
import type { Dispatch } from 'redux';

import type { Vehicle } from '@cobliteam/common-types';

import type {
  ReminderPrefill,
  UpcomingMaintenanceByVehicleId,
  WebData,
} from '@cobliteam/api-lib';

import type { MaintenanceState } from '../../store/maintenanceStore';
import { maskMaintenanceAsDoneRequest } from '../../store/RegisterMaintenance/actionCreators';
import { loadUpcomingMaintenancesRequest } from '../../store/UpcomingMaintenances/actionCreators';
import {
  selectFutureMaintenances,
  selectNextMaintenances,
} from '../../store/UpcomingMaintenances/selectors';

interface OwnProps {
  vehiclesWebData: WebData<Vehicle[]>;
  onRegisterReminderClick: () => void;
  onEditRemindersClick: () => void;
  onDeleteRemindersClick: () => void;
  onMarkAsDoneClick: () => void;
  onLoadPageContent: () => void;
}

interface StateProps {
  nextMaintenancesWebData: WebData<UpcomingMaintenanceByVehicleId>;
  futureMaintenancesWebData: WebData<UpcomingMaintenanceByVehicleId>;
}

interface DispatchProps {
  onMarkAsDoneClick: (prefill: ReminderPrefill) => void;
  onLoadPageContent: () => void;
}

const mapStateToProps = (state: MaintenanceState): StateProps => ({
  nextMaintenancesWebData: selectNextMaintenances(state),
  futureMaintenancesWebData: selectFutureMaintenances(state),
});

const mapDispatchToProps = (
  dispatch: Dispatch,
  ownProps: OwnProps
): DispatchProps => ({
  onMarkAsDoneClick: (prefill) => {
    dispatch(maskMaintenanceAsDoneRequest(prefill));
    ownProps.onMarkAsDoneClick();
  },
  onLoadPageContent: () => {
    dispatch(loadUpcomingMaintenancesRequest());
    ownProps.onLoadPageContent();
  },
});

export const MaintenanceRemindersContainer = connect<
  StateProps,
  DispatchProps,
  OwnProps,
  MaintenanceState
>(
  mapStateToProps,
  mapDispatchToProps
)(MaintenanceReminders);
